import type { ReferencedEntry } from 'contentful';
import React, { AllHTMLAttributes } from 'react';

import type { SideBySideAssembly } from 'api/contentful/contentTypes.cloverdotcom';
import { CarouselModule } from 'components/CarouselModule/CarouselModule';
import { isEntry } from 'utils/EntryUtil';

interface ISideBySideModuleProps extends AllHTMLAttributes<HTMLElement> {
  entry?: ReferencedEntry<SideBySideAssembly>;
}

export const SideBySideModule: React.FC<ISideBySideModuleProps> = ({ entry, ...props }) => {
  if (!isEntry(entry)) return null;

  return <CarouselModule entry={entry} {...props} />;
};
